<div class="field">
  <ng-content select="label"></ng-content>
  <div class="field__in">
    <div class="field__input field__input--password">
      <ng-content select="input"></ng-content>
      <div class="field__toggle ng-scope" (click)="changeType()">
        <app-icon [glyph]="'hd-eye-close'" [size]="'16'" [color]="'gray-dark'" *ngIf="!showPass"></app-icon>
        <app-icon [glyph]="'hd-eye-open'" [size]="'16'" [color]="'gray-dark'" *ngIf="showPass"></app-icon>
      </div>
    </div>
  </div>
</div>
